import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgEyeClosedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m16.47 17.96-.241-.438.241.438Zm-4.369 1.123.01-.5-.01.5Zm-4.33-1.201.237-.44-.237.44Zm.559-9.565c2.29-1.15 4.933-1.43 7.639-.004l.466-.885c-3.04-1.6-6.028-1.274-8.554-.004l.449.893Zm10.912 7.57 2.906 2.453.645-.764-2.906-2.453-.645.765Zm.685-.037a20.89 20.89 0 0 0 2.035-2.534l-.823-.567a19.895 19.895 0 0 1-1.937 2.412l.725.689Zm-3.215 2.548c1.08-.596 2.157-1.433 3.215-2.548l-.725-.689c-.997 1.05-1.994 1.82-2.973 2.361l.483.876Zm-.689-.215 1.618 3.241.895-.447-1.618-3.24-.895.446Zm-3.931 1.4c1.497.03 3.056-.323 4.62-1.185l-.483-.876c-1.412.779-2.798 1.087-4.118 1.06l-.02 1Zm-.49-.5v3.57h1v-3.57h-1Zm-4.067-.761c1.38.742 2.921 1.228 4.556 1.26l.02-1c-1.447-.028-2.834-.459-4.103-1.14l-.473.88Zm-.973 3.102 1.657-3.319-.895-.447-1.657 3.32.895.446ZM2.209 13.3a15.095 15.095 0 0 0 2.066 2.567l.707-.707a14.097 14.097 0 0 1-1.928-2.395l-.845.535Zm2.066 2.567c.937.937 2.038 1.798 3.26 2.455l.473-.88c-1.124-.605-2.147-1.404-3.026-2.282l-.707.707Zm-2.22 2.473 2.896-2.444-.645-.765-2.896 2.445.644.764Z"
      fill="#4D4D4D"
    />
  </svg>
);
const Memo = memo(SvgEyeClosedIcon);
export default Memo;
